import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import GuestSummary from 'pared/pages/Guest/SummaryV3'

import Summary from '../../Summary'
import { FROM_EXPO } from '../../constants'
import { IMessage } from '../../type'
import formatDate from '../formatDate'

export default function handleGuestSuggestions(
  responseData: any,
  brandLocationGroupId: number,
) {
  if (responseData?.locationGroupGuestSummary) {
    const messageId = uuidv4()
    const results: any = responseData.locationGroupGuestSummary

    const answerMessage: IMessage = {
      id: messageId,
      from: FROM_EXPO,
      content: (
        <div>
          <LocationAndDateRange>
            {results?.locationGroupName} ({formatDate(results?.startDate)} ~{' '}
            {formatDate(results?.endDate)})
          </LocationAndDateRange>
          <Summary
            summaryType={results?.summaryType}
            locationGroupId={results?.locationGroupId}
            brandLocationGroupId={brandLocationGroupId}
            startDate={results?.startDate}
            endDate={results?.endDate}
          />
        </div>
      ),
    }

    return answerMessage
  }

  if (responseData?.locationGuestSuggestions) {
    const messageId = uuidv4()
    const results: any = responseData.locationGuestSuggestions

    const answerMessage: IMessage = {
      id: messageId,
      from: FROM_EXPO,
      content: (
        <div>
          <LocationAndDateRange>
            {results?.locationName} ({formatDate(results?.startDate)} ~{' '}
            {formatDate(results?.endDate)})
          </LocationAndDateRange>
          <GuestSummary
            locationId={results?.locationId}
            startDate={results?.startDate}
            endDate={results?.endDate}
          />
        </div>
      ),
    }

    return answerMessage
  }

  return null
}

const LocationAndDateRange = styled.div`
  padding: 0 0 20px 0;
`
